// Actions
export const setArticles = ({ commit }, payload) => {
  commit('SET_ARTICLES', payload)
}
export const setArticlesError = ({ commit }) => {
  commit('SET_ARTICLES_ERROR')
}
export const setLoading = ({ commit }, payload) => {
  commit('SET_LOADING', payload)
}
export const setSources = ({ commit }, payload) => {
  commit('SET_SOURCES', payload)
}
export const setFiltroSources = ({ commit }, payload) => {
  commit('SET_FILTRO_SOURCES', payload)
}
export const setFiltroTermo = ({ commit }, payload) => {
  commit('SET_FILTRO_TERMO', payload)
}
export const resetArticles = ({ commit }) => {
  commit('RESET_ARTICLES')
}
